
export default (Vue) => {
    //定义一个空集合
    let service = {}
    // 获取该模块下，所有的service文件，获取后，准备合并完成后返回给调用层。
    const fileService = require.context('./modules', true, /\.js/);
    //轮循service文件后，进行合并操作。
    fileService.keys().forEach((moduleFilePath) => {
        const moduleName = moduleFilePath.replace(/^\.\/(.*)\/.\w+$/, '$1');
        const tempService = fileService(moduleName);
        //合并服务
        service = Object.assign(service, tempService.default(Vue));
    });
    //返回该模块下合并后的服务
    return service;
}
